
import { AbstractControl, AsyncValidatorFn, FormArray, ValidationErrors } from '@angular/forms';
import { debounceTime, distinctUntilChanged, firstValueFrom, map } from 'rxjs';
import { UsersService } from "src/app/api/users.service";
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export function atLeastOneSelected(): (control: AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl) => {
    const fa = control as FormArray;
    const anySelected = fa.controls.some(c => !!c.value);
    return anySelected ? null : { oneRequired: true };
  };
}

export function emailDuplicateValidator(users: UsersService): AsyncValidatorFn {
  return (control: AbstractControl) => {
    const value = (control.value || '').trim();
    if (!value) return Promise.resolve(null);
    // return firstValueFrom(
    //   users.isEmailTaken(value).pipe(
    //     //debounceTime(300),
    //     //distinctUntilChanged(),
    //     map(res => !res.exists ? { emailTaken: true } : null )
    //   )
    // );
       // Ensure the observable completes; on error treat as valid = null
   return firstValueFrom(
    users.isEmailTaken(value).pipe(
      map(res => {
        // Assume service returns { exists: boolean; message?: string }
        if (!res?.exists) {
          return {
            emailTaken: {
              exists: true,
              message: res.message ?? 'Email already exists.'
            }
          };
        }
        return null;
      }),
      catchError(() => of(null))
    )
  
    )
  };
}
